import { render, staticRenderFns } from "./ownspace.vue?vue&type=template&id=12836028&scoped=true&"
import script from "./ownspace.vue?vue&type=script&lang=ts&"
export * from "./ownspace.vue?vue&type=script&lang=ts&"
import style0 from "./ownspace.vue?vue&type=style&index=0&id=12836028&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12836028",
  null
  
)

component.options.__file = "ownspace.vue"
export default component.exports